<template>
  <v-app>
    <portal-sysbar></portal-sysbar>
    <div class="main-content">
      <portal-aside></portal-aside>
      <portal-title :title="title"></portal-title>
      <portal-breadcumb></portal-breadcumb>

      <div class="content">
        <v-row>
          <v-col md="7">
            <v-card>
              <v-card-title class="portal-deep-blue-bg">
                Batterie
                <v-icon class="ml-auto" color="#fff"> mdi-battery </v-icon>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  dense
                  :headers="headers"
                  :items="items"
                  item-key="name"
                  class="elevation-1"
                ></v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card flat class="text-center">
              <v-btn tile color="#6DB7A2" dark>
                GERER MES ALERTES
                <v-icon right> mdi-cog </v-icon>
              </v-btn>
            </v-card>
            <v-card flat class="text-center mt-10">
              <v-card-text class="">
                <apex-charts
                  type="donut"
                  :options="chartOptions"
                  :series="series"
                  width="70%"
                ></apex-charts>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import ApexCharts from "vue-apexcharts";

export default {
  name: "MonitoringPage",
  data: () => ({
    title: "Monotoring technique",
    headers: [
      {
        text: "Locomotive",
        align: "start",
        value: "loconum",
      },
      { text: "Batterie", value: "statut" },
      { text: "Niveau de criticite", value: "level" },
    ],
    items: [],
    series: [5, 6, 10],
    
    chartOptions: {
      chart: {
        type: "donut",
      },
      colors:['#DF0024', '#EEBB07', '#9AD6C5'],
      labels:['Critique (<80V)','Aleete (>=80 & <90)','Normal (>= 90)'],
      dataLabels: {
        enabled: false,
      },
      legend:{
          position:"bottom" ,
          fontSize: '16px',
          fontFamily: 'calibri'
      }
    },
  }),
  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    ApexCharts,
  },
};
</script>

<style scoped>
.portal-green-bg {
  height: 59px;
  color: #fff;
}

.theme--light.v-data-table-header {
  background-color: #00475a;
  color: #9faaaf;
}

tbody {
  color: #00475a;
  font-weight: bolder;
}

.portal-deep-blue-bg {
  height: 59px;
  color: #fff;
  text-transform: uppercase;
}

.v-card__text {
  padding: 0px;
}
</style>